export const API_CONFIG = {
  LIFF_API_KEY: process.env.VUE_APP_LIFF_API_KEY || 'liff_public_key_2023',
}

export const getLiffApiKey = (): string => {
  return API_CONFIG.LIFF_API_KEY
}

export const getLiffApiHeaders = (): Record<string, string> => {
  return {
    'X-API-Key': getLiffApiKey(),
    'Content-Type': 'application/json',
  }
}
